"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckGroupCard = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var CheckGroup_1 = require("../CheckGroup");
var StyledCard = styled_components_1.default(antd_1.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-card-head-title {\n    padding: 12px 0px;\n  }\n"], ["\n  .ant-card-head-title {\n    padding: 12px 0px;\n  }\n"])));
/*
TODO:
1. Use merge-deep for deep prop merging. Right now the cardProps.style will be overwritten by option.cardProps.style
*/
var CheckGroupCard = function (_a) {
    var cardProps = _a.cardProps, props = __rest(_a, ["cardProps"]);
    return (react_1.default.createElement(CheckGroup_1.CheckGroup, __assign({}, props, { rowProps: { gutter: [12, 16] }, renderItem: function (_a) {
            var _b, _c, _d;
            var node = _a.node, activeColor = _a.activeColor, isChecked = _a.isChecked, rest = _a.rest;
            return (react_1.default.createElement(StyledCard, __assign({}, cardProps, rest === null || rest === void 0 ? void 0 : rest.cardProps, { style: __assign({ padding: "0px 1rem", cursor: "pointer", border: "1px solid " + (isChecked ? activeColor : "#D9D9D9"), borderRadius: "3px" }, (_b = rest === null || rest === void 0 ? void 0 : rest.cardProps) === null || _b === void 0 ? void 0 : _b.style), headStyle: __assign({ padding: 0 }, (_c = rest.cardProps) === null || _c === void 0 ? void 0 : _c.headStyle), bodyStyle: __assign({ padding: "12px 0px" }, (_d = rest.cardProps) === null || _d === void 0 ? void 0 : _d.bodyStyle), title: node })));
        } })));
};
exports.CheckGroupCard = CheckGroupCard;
var templateObject_1;
